import { OrderInfo } from '@@partner:types:app'
import React from 'react'
import { formatDate } from '@@partner:helpers/util'
import { generatePath } from 'react-router-dom'
import { ROUTE_ORDERS_VIEW_ORDER } from '@@partner:config/routes'
import { Link } from 'react-router-dom'

import './OrderCard.scss'
import { usePartner } from '@@partner:helpers/hooks/auth'

type OrderCardProps = {
  order: OrderInfo
}

export default function OrderCard ({
  order
}: OrderCardProps) {
  const { brandSlug } = usePartner()
  const orderUrl = generatePath(ROUTE_ORDERS_VIEW_ORDER, { brandSlug, orderId: order.id })

  return (
    <div className="OrderCard">
      <Link to={orderUrl} target="_blank">
        <div className="OrderCard__Header">
          <strong>Заказ #{order.id}</strong>
        </div>
        <div className="OrderCard__Details">
          <div>Магазин: {order.shop?.name || 'Не указан'}</div>
          <div>Зона доставки: {order.deliveryZone?.name || 'Не указана'}</div>
          <div>Дата: {formatDate(new Date(order.placedAt))}</div>
          <div>Позиций: {order.customerProducts?.length || 0}</div>
        </div>
      </Link>
    </div>
  )
}